// extracted by mini-css-extract-plugin
export var quantityInput = "_m1-0";